import React from 'react';
import {FieldArray, FieldArrayConfig, FieldArrayRenderProps} from "formik";
import FloorFormFields from "./FloorFormFields";
import Button from 'components/Button';
import {PlusIcon} from '@heroicons/react/solid';
import {FloorData} from "../../../types/Floor";
import {useOperator} from "../../../context/OperatorContext";
import {Building} from "../../../types/Building";

// Helpers ----

const newFloor: FloorData = {
  key: crypto.randomUUID(), // Unique key for React list rendering
  name: '',
  height: undefined,
  area: undefined,
  order: undefined,
}

// Component ----

type FloorListFieldProps = FieldArrayConfig & {
  readOnly?: boolean
  building?: Building | null
}

function FloorListField({readOnly = false, building, ...props}: FloorListFieldProps) {
  const {termFor} = useOperator();

  return (
    <FieldArray {...props}>
      {(helpers: FieldArrayRenderProps) => {

        const {push, form} = helpers
        const floorData = form.values[props.name] as Array<FloorData> | undefined

        return (
          <div>
            <ul className='flex flex-col gap-4'>
              {floorData?.map((floor, index) => (
                <li key={floor.id ?? floor.key ?? index}>
                  <FloorFormFields
                    building={building}
                    floor={floor}
                    index={index}
                    helpers={helpers}
                    readOnly={readOnly}
                  />
                </li>
              ))}
            </ul>

            <div className={(floorData && floorData.length < 1) ? 'mt-0' : 'mt-4'}>
              <Button
                color={Button.colors.SECONDARY}
                icon={PlusIcon}
                size={Button.sizes.X_SMALL}
                onClick={() => push({...newFloor})}
                disabled={readOnly}
              >
                Add {termFor('floor')}
              </Button>
            </div>
          </div>
        )
      }}
    </FieldArray>
  );
}

export default FloorListField;